<template>
    <div class="main order">
        <van-tabs v-model="active" @change="loadOrders">
            <van-tab :title="'全部订单'"/>
            <van-tab :title="'退款/售后'"/>
        </van-tabs>
        <router-view></router-view>
    </div>
</template>
<script>
import Vue from 'vue';
import { Tab, Tabs,Tabbar, TabbarItem } from 'vant';

Vue.use(Tab).use(Tabs);
Vue.use(Tabbar).use(TabbarItem);
export default {
    name: 'ManageOrderList',
    data(){
        return {
            active: 0, // 当前高亮索引
        }
    },
    created(){ 
      this.watchStatus(this.$route.params.status)
    },
    methods: {
      loadOrders(index,title){
        let status = '' // 订单状态
        switch (index) {
          case 1:
            status = 'refund'
            break;
          default:
            status = 'false'
        }
        // 根据状态刷不同列表组件
        this.$router.replace({ name: 'manageorderlistrepeat', params: { status: status}})
      },
      loadView(){
        clubGroupCourse  //团课
        clubPtCourse  //私教课
        course //月卡  练球卡
      },
      watchStatus(sta){
        // 监听高亮
        switch (sta) {
          case 'refund': // 待支付
            this.active = 1;
            break;
          default:  // 全部
            this.active = 0;
        }
      }
    },
    watch:{
      $route(to,from){
        this.watchStatus(to.params.status)        
      }
    }
}
</script>
<style lang="less">
.order.main{
  padding-bottom: 0;
  & .van-tab--active {
      color: #4b0;
  }
  & .van-tabs__line {
      background-color: #4b0;
  }
}
.no-record{
    margin: .6rem;
    &>.iconfont{
        font-size: .6rem;
        color: #ccc;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/ManageOrderList.vue